import React, { useEffect, useState } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { cpp } from '@codemirror/lang-cpp';
import { java } from '@codemirror/lang-java';
import { javascript } from '@codemirror/lang-javascript';
import { python } from '@codemirror/lang-python';
import { duotoneLight, duotoneDark } from '@uiw/codemirror-theme-duotone';
import { xcodeLight, xcodeDark } from '@uiw/codemirror-theme-xcode';
import { sublime } from '@uiw/codemirror-theme-sublime';
import { okaidia } from '@uiw/codemirror-theme-okaidia';
import { githubLight, githubDark } from '@uiw/codemirror-theme-github';
import { darcula } from '@uiw/codemirror-theme-darcula';
import { dracula } from '@uiw/codemirror-theme-dracula';
import { bespin } from '@uiw/codemirror-theme-bespin';
import { atomone } from '@uiw/codemirror-theme-atomone';
import { androidstudio } from '@uiw/codemirror-theme-androidstudio';
import { indentUnit } from '@codemirror/language';
import { EditorState } from '@codemirror/state';

interface CodeIDEProps {
	codeText: any;
	setCodeText: any;
	codingLanguage: any;
	editorTheme: any;
	codeRef?: any;
	fontSize: number;
}

const CodeMirrorEditor: React.FC<CodeIDEProps> = ({
	codeText,
	setCodeText,
	codingLanguage,
	editorTheme,
	codeRef,
	fontSize,
}) => {
	const handleEditorChange = (value: any, event: any) => {
		setCodeText(value);
	};

	const [theme, setTheme] = useState<any>(duotoneLight);

	const languageSelect = (tag: string) => {
		if (tag === 'javascript') setLang(javascript);
		if (tag === 'python') setLang(python);
		if (tag === 'java') setLang(java);
		if (tag === 'cpp') setLang(cpp);
	};

	const themeSelect = (themeOption: string) => {
		if (themeOption === 'duotoneLight') setTheme(duotoneLight);
		if (themeOption === 'duotoneDark') setTheme(duotoneDark);
		if (themeOption === 'xcodeLight') setTheme(xcodeLight);
		if (themeOption === 'xcodeDark') setTheme(xcodeDark);
		if (themeOption === 'sublime') setTheme(sublime);
		if (themeOption === 'okaidia') setTheme(okaidia);
		if (themeOption === 'githubLight') setTheme(githubLight);
		if (themeOption === 'githubDark') setTheme(githubDark);
		if (themeOption === 'darcula') setTheme(darcula);
		if (themeOption === 'dracula') setTheme(dracula);
		if (themeOption === 'bespin') setTheme(bespin);
		if (themeOption === 'atomone') setTheme(atomone);
		if (themeOption === 'androidstudio') setTheme(androidstudio);
	};

	const [lang, setLang] = useState<any>(java);

	useEffect(() => {
		languageSelect(codingLanguage);
	}, [codingLanguage]);

	useEffect(() => {
		themeSelect(editorTheme);
	}, [editorTheme]);

	console.log(codingLanguage);

	return (
		<div
			className={'code-editor'}
			ref={codeRef}
			onContextMenu={(e) => {
				// console.log(langs[codingLanguage]())
				e.preventDefault();
			}}
			style={{ fontSize: `${fontSize}px` }}
		>
			<CodeMirror
				className={'main-editor'}
				style={{
					fontFamily: "'Source Code Pro', monospace !important",
				}}
				value={codeText}
				height="100%"
				extensions={[
					lang,
					indentUnit.of('    '),
					EditorState.tabSize.of(4),
					EditorState.changeFilter.of(() => true),
				]}
				theme={theme}
				onChange={handleEditorChange}
				basicSetup={{
					lineNumbers: true,
					highlightActiveLineGutter: true,
					highlightSpecialChars: true,
					foldGutter: true,
					drawSelection: true,
					dropCursor: true,
					allowMultipleSelections: true,
					indentOnInput: true,
					syntaxHighlighting: true,
					bracketMatching: true,
					closeBrackets: true,
					autocompletion: true,
					rectangularSelection: true,
					crosshairCursor: true,
					highlightActiveLine: true,
					highlightSelectionMatches: true,
					closeBracketsKeymap: true,
					defaultKeymap: true,
					searchKeymap: true,
					historyKeymap: true,
					foldKeymap: true,
					completionKeymap: true,
					lintKeymap: true,
				}}
			/>
		</div>
	);
};

export default CodeMirrorEditor;
